import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import { qrCodePng as pngSrc } from 'garaje/mirage/helpers/qr-code-png';
import { qrCodeSvg as svgSrc } from 'garaje/mirage/helpers/qr-code-svg';

export default Factory.extend({
  name(i) {
    return `Entrance: ${i + 1}`;
  },

  pngSrc,
  svgSrc,

  signInUrl() {
    const key = faker.string.alphanumeric(10, { bannedChars: ['a', 'e', 'i', 'o', 'u'] }).toLowerCase();

    return `https://visitors.envoy.com/in/${key}`;
  },

  printerStatus: 'connected',

  lastHeartbeatAt: () => new Date(),
  createdAt: () => new Date(),
  updatedAt: () => new Date(),

  withPrinter: trait({
    afterCreate(record, server) {
      const printer = server.create('printer', { ip: '192.168.1.1', location: record.location });

      record?.update({ printer, printerStatus: printer.status });
    },
  }),

  withVisitorEntrance: trait({
    afterCreate(record, server) {
      const visitorEntrance = server.create('visitor-entrance', {
        useLocationAddress: true,
        location: record.location,
      });

      record?.update({ visitorEntrance });
    },
  }),
});
